import { PropsWithChildren } from "react";

function CommonPageElements<T>({ children }: PropsWithChildren<T>) {
    return <div>{children}</div>;
}

export default CommonPageElements;
